import i18n from "./i18n";
import { throwModal } from "../view/sharedComponents/errors/throwError/throwError";

export const serverError = () => {
  throwModal("error", {
    title: i18n.t("errors.serverError"),
    content: i18n.t("errors.serverErrorDetail"),
  });
};
